import { PreliminaryDDStatus } from './preliminaryDueDiligence';

export interface AdminDueDiligenceListingResponse {
  totalPages: number;
  totalElements: number;
  items: AdminDueDiligenceListingItem[];
}

export interface AdminPreliminaryDueDiligenceListingResponse {
  totalPages: number;
  totalElements: number;
  items: AdminPreliminaryDueDiligenceListingItem[];
}

export enum DueDiligenceStatus {
  ASSIGNED = 'ASSIGNED',
  IN_PROGRESS = 'IN_PROGRESS',
  OVERDUE = 'OVERDUE',
  RECEIVED = 'RECEIVED',
  CLOSED = 'CLOSED',
  PENDING_REVIEW = 'PENDING_REVIEW',
}

export interface AdminDueDiligenceListingItem {
  id: string;
  clientCode: string;
  companyName: string;
  templateType: string;
  createdAt: string;
  dueDate: string;
  status: DueDiligenceStatus;
  adminAttentionCount: number;
  receivedCount: number;
  applicableCount: number;
  draftCount: number;
  paused: boolean;
}

export interface AdminPreliminaryDueDiligenceListingItem {
  id: string;
  clientCode: string;
  companyName: string;
  templateType: string;
  createdAt: string;
  dueDate: string;
  status: PreliminaryDDStatus;
  adminAttentionCount: number;
  pocEmails: string[];
  paused: boolean;
}
